<template>
    <div class="agency-newsletter-section section-space--ptb_120 bg-gray-3">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="digital-agency-section-title text-center section-space--mb_60">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">493 businesses signed up last <br> week. Join them! </h3>
                    </div>
                    <!-- newsletter form -->
                    <div class="newsletter-form--two section-space--mb_30 text-center wow move-up">
                        <form action="#">
                            <input type="text" placeholder="Your name">
                            <input type="email" placeholder="Email">
                            <button class="ht-btn ht-btn-md">Subscribe</button>
                        </form>
                    </div>
                    <!-- newsletter text -->
                    <h6 class="sub-heading text-center wow move-up">What’s next in AeroLand? <a href="#" class="hover-style-link hover-style-link--green">Learn more</a></h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsletterThree'
    }
</script>